<template>
  <div class="table-container">
    <div class="table-responsive datatable-vue">
      <b-table
        show-empty
        stacked="md"
        :items="state.tableData"
        :fields="state.fields"
      >

        <!-- Product Name -->
        <template #cell(product_name)="row">
          {{ row.item.product_name }}
        </template>

        <!-- Delivered Quantity -->
        <template #cell(delivered_quantity)="row">
          {{ row.item.delivered_quantity }}
        </template>

        <!-- Remaining Returnable -->
        <template #cell(remaining_returnable)="row">
          {{ row.item.remaining_returnable }}
        </template>

        <!-- Return Quantity -->
        <template #cell(return_quantity)="row">
          <input
            class="form-control"
            type="number"
            :min="0"
            :max="row.item.remaining_returnable"
            :value="row.item.return_quantity"
            @input="onInput(row.index, $event)"
          />
        </template>

      </b-table>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, watch } from "vue";

export default defineComponent({
  name: "item-table",

  props: {
    tableData: {
      type: Array,
      required: true
    }
  },

  setup(props, { emit }) {
    const state = reactive({
      tableData: [],
      fields: [
        { key: "product_name", label: "Product" },
        { key: "delivered_quantity", label: "Delivered Qty" },
        { key: "remaining_returnable", label: "Remaining Returnable" },
        { key: "return_quantity", label: "Return Qty" }
      ]
    });

    // 🔹 Map API data
    const mapProducts = (products) => {
      return products.map((item) => ({
        product_id: item.product_id,
        product_name: item.product_name,
        delivered_quantity: item.delivered_quantity,
        remaining_returnable: item.remaining_returnable,

        return_quantity: 0 // default
      }));
    };

    // 🔹 Sync from parent
    watch(
      () => props.tableData,
      (val) => {
        if (val) {
          state.tableData = mapProducts(val);
        }
      },
      { immediate: true }
    );

    // 🔹 Handle input safely
    const onInput = (index, event) => {
      let value = event.target.value;

      value = value === "" ? 0 : Number(value);

      const item = state.tableData[index];

      // clamp max
      if (value > item.remaining_returnable) {
        value = item.remaining_returnable;
      }

      // clamp min
      if (value < 0) {
        value = 0;
      }

      item.return_quantity = value;

      emitChange();
    };

    // 🔹 Emit ONLY required data
    const emitChange = () => {
      const payload = state.tableData.map((item) => ({
        product_id: item.product_id,
        return_quantity: item.return_quantity
      }));

      emit("itemsUpdated", payload);
    };

    return {
      state,
      onInput
    };
  }
});
</script>

<style scoped>
.table-container {
  width: 100%;
}
</style>